import { AUTH_COOKIE_DOMAIN } from '../config';

const COOKIE_NAME = 'mgk_auth_tkn';

export function setAuthTokenCookie(token) {
    document.cookie = [
        `${COOKIE_NAME}=${encodeURIComponent(token)}`,
        `Path=/`,
        `Domain=${AUTH_COOKIE_DOMAIN}`,
        `Secure`,
        `SameSite=None`,
    ].join('; ');
}

export function getAuthTokenFromCookie() {
    const match = document.cookie.match(new RegExp(`(^| )${COOKIE_NAME}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : null;
}

export function clearAuthTokenCookie() {
    document.cookie = [
        `${COOKIE_NAME}=`,
        `Path=/`,
        `Domain=${AUTH_COOKIE_DOMAIN}`,
        `Expires=Thu, 01 Jan 1970 00:00:00 GMT`,
    ].join('; ');
}
